import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-start gap-3" }
const _hoisted_2 = ["src", "alt"]

import { PropType } from 'vue'
import { DropdownOption } from '@/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkSelectOption',
  props: {
  active: Boolean,
  selected: Boolean,

  option: {
    type: Object as PropType<DropdownOption>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.option.icon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.option.icon,
          alt: __props.option.display,
          class: _normalizeClass(["selected-icon rounded-full", { 'w-6 h-6 min-w-6': !__props.selected, 'w-10 h-10 min-w-10': __props.selected }])
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["tracking-1", { 'text-2xl': __props.selected }]),
      "data-cy": "network-selector-selected-option-text-content"
    }, _toDisplayString(__props.option.display), 3)
  ]))
}
}

})